import _ from 'lodash';
import numeral from 'numeral';
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import BuilderAx           from 'app/actions/company-admin/builder-campaign';
import RoutingAx           from 'app/actions/routing';
import Checkbox            from 'app/components/common/checkbox';
import Confirm             from 'app/components/common/confirm';
import DatePicker          from 'app/components/common/date-picker';
import Icon                from 'app/components/common/icon';
import NumberInput         from 'app/components/common/number-input';
import Link                from 'app/components/common/link';
import MatchRatioSelector  from 'app/components/common/match-ratio-selector';
import MonetaryInput       from 'app/components/common/monetary-input';
import NonprofitInput      from 'app/components/common/nonprofit-input';
import RteEditor           from 'app/components/common/rich-text/editor';
import SegmentedInput      from 'app/components/common/segmented-selector-input';
import StandardInput       from 'app/components/common/standard-input';
import StandardSelect      from 'app/components/common/standard-select';
import TimezoneInput       from 'app/components/common/timezone-input';
import Tip                 from 'app/components/common/tip';
import UploadedImageInput  from 'app/components/common/uploaded-image-input';
import BuilderDriveGood    from 'app/components/company-admin/campaigns/builder-drive-good';
import BuilderLink         from 'app/components/company-admin/common/builder-link';
import EntityInput         from 'app/components/company-admin/common/entity-input';
import Builder             from 'app/components/company-admin/layout/builder';
import BuilderFooter       from 'app/components/company-admin/layout/builder-footer';
import BuilderIterable     from 'app/components/company-admin/layout/builder-iterable';
import BuilderSection      from 'app/components/company-admin/layout/builder-section';
import BuilderSectionGroup from 'app/components/company-admin/layout/builder-section-group';
import format              from 'app/helpers/format';
import Ps                  from 'app/helpers/publish-statuses';
import AuthSlx             from 'app/selectors/auth';
import CadminSlx           from 'app/selectors/company-admin/';
import BuilderSlx          from 'app/selectors/company-admin/builder-campaign';
import FfSlx               from 'app/selectors/feature-flags';



import GrantSysDuck          from 'app/ducks/company-admin/grant-system';
import paths from 'app/paths';
import history from 'app/history';
import ToastAx from 'app/actions/toast';


class GrantProgramLandingPageBuilder extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      hasTouched: false,
      hasSubmitted: false,
      isSaving: false,
    };

    this.onChangeTitle = this.onChangeTitle.bind(this);
    this.onChangeImg = this.onChangeImg.bind(this);
    this.onChangeLandingText = this.onChangeLandingText.bind(this);
    this.onChangeOpenDate = this.onChangeOpenDate.bind(this);
    this.onChangeCloseDate = this.onChangeCloseDate.bind(this);
    this.onClickSave = this.onClickSave.bind(this);
  }

  componentDidMount() {

  }

  componentWillUnmount() {

  }

  /*
   *  Helpers
   */

  get saveAttrs() {
    const {program} = this.props;
    const sanitizeString = (str) => {
      return (str || '').trim() || null;
    }
    return {
      title: sanitizeString(program.title),
      landingText: sanitizeString(program.landingText),
      openDateStr: program.openDateStr,
      closeDateStr: program.closeDateStr,
      imgPath: program.imgPath,
    };
  }

  get validations() {
    const {program} = this.props;
    const v = {};
    if (!program.title) v.title = ['required'];
    if (!Object.keys(v).length) return null;
    return v;
  }

  get visibleValidations() {
    if (!this.state.hasTouched) return null;
    if (!this.state.hasSubmitted) return null;
    return this.validations;
  }

  onChangeTitle(event) {
    const title = event.target.value;
    this.setState({hasTouched: true});
    this.props.setAttrs({title});
  }

  onChangeImg(imgPath) {
    this.setState({hasTouched: true});
    this.props.setAttrs({imgPath});
  }

  onChangeLandingText(md) {
    this.setState({hasTouched: true});
    this.props.setAttrs({landingText: md});
  }

  onChangeOpenDate(dateStr) {
    this.setState({hasTouched: true});
    this.props.setAttrs({openDateStr: dateStr});
  }
  onChangeCloseDate(dateStr) {
    this.setState({hasTouched: true});
    this.props.setAttrs({closeDateStr: dateStr});
  }

  onClickSave() {
    if (this.validations) {
      this.setState({hasSubmitted: true});
      return;
    }
    this.setState({hasSubmitted: true, isSaving: true});
    this.props.update(this.saveAttrs).then(() => {
      this.setState({isSaving: false});
      this.props.toastSuccess('Program settings updated.');
      const managePath = paths.cadminGrantProgram(this.props.program.company.slug, this.props.program.id, {tab: 'config'});
      history.push(managePath);
    }).catch((error) => {
      console.error(error);
      this.setState({isSaving: false});
    });
  }

  renderFooter() {
    const btnDisabled = (() => {
      if (this.state.isSaving) return true;
      if (this.visibleValidations) return true;
      if (!this.state.hasTouched) return true;
      return false;
    })();
    const btnText = (() => {
      return 'Save';
    })();

    return (
      <BuilderFooter>
        {!!this.visibleValidations && (
          <div className="cadmin-builder-bottom-validations">
            <p>Oops! There are some required fields above that need your attention.</p>
          </div>
        )}
        <div className="cadmin-builder-bottom-actions">
          <button className="btn green" disabled={btnDisabled} onClick={this.onClickSave}>{btnText}</button>
        </div>
      </BuilderFooter>
    );
  }

  render() {
    const {company, program} = this.props;

    return (
      <Builder footer={this.renderFooter()} className="cadmin-camb">

        <BuilderSection title="Title, Image, & Description">
          <StandardInput name="title" value={program.title || ''} onChange={this.onChangeTitle} validations={this.visibleValidations} label="Title" />
          <UploadedImageInput onChange={this.onChangeImg} name="imgPath" label="Image File" pathValue={program.imgPath} />
          <RteEditor onChange={this.onChangeLandingText} name="landingText" placeholder="Describe your grant program here..." initialMd={program.landingText || ''} tall />
        </BuilderSection>

        <BuilderSection title="Open & Close Dates">
          <DatePicker className="_w-100 _mb-15" dateStr={program.openDateStr || null} name="openDateStr" onChange={this.onChangeOpenDate} placeholder="Open Date" allowClear />
          <DatePicker className="_w-100" dateStr={program.closeDateStr || null} name="closeDateStr" onChange={this.onChangeCloseDate} placeholder="Close Date" allowClear />
        </BuilderSection>

      </Builder>
    );
  }

}

GrantProgramLandingPageBuilder.propTypes = {
  program: PropTypes.object.isRequired,
};

const stateToProps = (state) => ({
  currentUser: AuthSlx.currentUser(state),
  company: CadminSlx.company(state),
  // savePending: FormsDuck.Slx.bldrSavePending(state),
});

const dispatchToProps = (dispatch, ownProps) => ({
  setAttrs: (keyVals) => dispatch(GrantSysDuck.Ax.setBuilderLandingPageProgram(keyVals)),
  update: (attrs) => dispatch(GrantSysDuck.Ax.programsUpdate(ownProps.program.company.id, ownProps.program.id, attrs)),
  toastSuccess: (msg) => dispatch(ToastAx.success(msg)),
});

export default connect(stateToProps, dispatchToProps)(GrantProgramLandingPageBuilder);
